import { render, staticRenderFns } from "./galeria.vue?vue&type=template&id=07002a3c&"
import script from "./galeria.vue?vue&type=script&lang=js&"
export * from "./galeria.vue?vue&type=script&lang=js&"
import style0 from "./galeria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports